import { Component, inject, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CivicBudgetSubmitProjectForm } from './forms/civic-budget-submit-project.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../common/validation-errors/validation-errors.component';
import { FileUploaderComponent } from '../../../../common/file-uploader/file-uploader.component';
import { Store } from '@ngrx/store';
import { selectBudgetById, selectLoading, selectPending } from '../../../../store/selectors/civic-budget.selectors';
import { loadBudgets, submitProject } from '../../../../store/actions/civic-budget.actions';
import { SpinnerComponent } from '../../../../common/spinner/spinner.component';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-civic-budget-submit-project-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterLink,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    FileUploaderComponent,
    SpinnerComponent,
    NgxMaskDirective
  ],
  providers: [CivicBudgetSubmitProjectForm],
  templateUrl: './civic-budget-submit-project-page.component.html'
})
export class CivicBudgetSubmitProjectPageComponent implements OnInit {

  public form: CivicBudgetSubmitProjectForm = inject(CivicBudgetSubmitProjectForm);

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  private budgetId: string = this.route.snapshot.params['id'];

  public budget: Signal<any> = this.store$.selectSignal(selectBudgetById(this.budgetId));

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public submit(): void {
    if (this.form.valid) {
      this.store$.dispatch(
        submitProject({
          payload: {
            ...this.form.toWriteModel(),
            budget: this.budgetId
          },
          successFnc: () => {
            this.router.navigate(['../'], {
              relativeTo: this.route,
              state: { message: 'Projekt został zgłoszony!' }
            });
          },
          failureFnc: (e) => {
            this.router.navigate(['../'], {
              relativeTo: this.route,
              state: { error: 'Projekt nie został zgłoszony: ' + e.message }
            });
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadBudgets({}));
  }
}
